import { ref, watch } from "vue"

interface MFAModalOptions {
	onSuccess?: (token: string) => void
	onError?: (error: Error) => void
}

const isModalVisible = ref(false)
let resolvePromise: ((token: string) => void) | null = null
let rejectPromise: ((error: Error) => void) | null = null

function handleSuccess(token: string) {
	if (resolvePromise) {
		resolvePromise(token)
		resolvePromise = null
		rejectPromise = null
	}
}

function handleError(error: Error) {
	if (rejectPromise) {
		rejectPromise(error)
		resolvePromise = null
		rejectPromise = null
	}
}

function closeModal() {
	isModalVisible.value = false
}

watch(isModalVisible, newVal => {
	if (!newVal && rejectPromise) {
		handleError(new Error("MFA modal closed"))
	}
})

export function useMfaModal() {
	const showModal = (options?: MFAModalOptions): Promise<string> => {
		isModalVisible.value = true

		return new Promise<string>((resolve, reject) => {
			resolvePromise = (token: string) => {
				options?.onSuccess?.(token)
				resolve(token)
			}

			rejectPromise = (error: Error) => {
				options?.onError?.(error)
				reject(error)
			}
		})
	}

	return {
		isModalVisible,
		showModal,
		handleSuccess,
		handleError,
		closeModal
	}
}
